/**
 * i18n entry point.
 *
 * Today the app ships in Norwegian only, so `t` is just a direct re-export
 * of `nb`. The indirection exists so:
 *
 *   1. Components never import a locale file directly — they only see `t`.
 *      Switching the active locale later is a one-line change here.
 *   2. The `Strings` type acts as a contract: every additional locale must
 *      match the shape of `nb`, caught at compile time.
 *
 * To add a new locale:
 *
 *   1. Create `<code>.ts` exporting `const <code>: Strings = { … }`.
 *      TypeScript will fail the build until every key is translated.
 *   2. Decide how the active locale is selected (`navigator.language`, a
 *      user preference, a route param, …) and switch on it below.
 *   3. Date/number formatters in `lib/format.ts` also pin `"nb-NO"` — update
 *      them in the same pass.
 */

import { nb, type Strings } from "./nb";

export const t: Strings = nb;
export type { Strings };
